<template>
  <component :is="Template" />
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, computed } from "vue";
import {
  injectTemplateSize,
  LARGE_RESPONSIVE,
  LEADERBOARD,
  LARGE_LEADERBOARD,
  MOBILE_LEADERBOARD,
  LMLB,
  MPU,
  LARGE_MPU,
  SMALL_RESPONSIVE,
  BILLBOARD,
  SKYSCRAPER
} from "@fresh8/ad-data-composition/src/useTemplateSize";

export default defineComponent({
  name: "TemplateSizeSelector",
  setup() {
    const template = injectTemplateSize();
    const Template = computed(() => {
      switch (template?.size.value.name) {
        // Fixed sizes
        case MPU.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/mpu/Wrapper.vue`)
          );
        case LARGE_MPU.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/large-mpu/Wrapper.vue`)
          );
        case SKYSCRAPER.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/skyscraper/Wrapper.vue`)
          );
        case LEADERBOARD.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/leaderboard/Wrapper.vue`)
          );
        case LARGE_LEADERBOARD.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/leaderboard/Wrapper.vue`)
          );
        case MOBILE_LEADERBOARD.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/mobile-leaderboard/Wrapper.vue`)
          );
        case LMLB.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/lmlb/Wrapper.vue`)
          );
        case BILLBOARD.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/billboard/Wrapper.vue`)
          );

        // Responsive sizes
        case SMALL_RESPONSIVE.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/small-responsive/Wrapper.vue`)
          );

        case LARGE_RESPONSIVE.name:
          return defineAsyncComponent(() =>
            import(`./template-sizes/large-responsive/Wrapper.vue`)
          );
        default:
          return undefined;
      }
    });

    return {
      Template
    };
  }
});
</script>
